<template>
  <v-card-actions class="actions hidden-md-and-up">
    <v-container fluid>
      <v-layout wrap align-center class="card-actions">
        <v-flex xs6 class="text-left">
          <v-btn class="action-button" text id="details-style" :to="'/environments/' + id + '/details'">Details <v-icon right>fas fa-chevron-right</v-icon></v-btn>
        </v-flex>
        <v-flex xs6 class="text-right">
          <span class="status">{{ status }}</span>
          <v-btn id="run-btn-style"><v-icon small left>fas fa-play</v-icon>Run</v-btn>
        </v-flex>
      </v-layout>
    </v-container>
  </v-card-actions>
</template>

<script>
  export default {
    data() {
      return {}
    },
    props: [ 'id', 'status' ]
  }
</script>